import { Product } from 'core/product/Product';
import React from 'react';
import { ProductFilter } from './ProductFilter';
import { SmartCampaignConfig } from 'core/configuration/SmartCampaignConfig';

/**
 * ProductListDataContextType
 * @description ProductListDataContextType
 * @since 2024-10-25
 * @export
 * @interface ProductListDataContextType
 * @property {string} [brandContext]
 * @property {Product[]} autoSelectedProducts 智能選品
 * @property {Product[]} selectedProducts 手動選品
 * @property {SmartCampaignConfig} [smartCampaignConfig]
 * @property {(fn: (autoSelectedProducts: Product[]) => Product[]) => void} handleAutoSelectedProducts
 * @property {(fn: (selectedProducts: Product[]) => Product[]) => void} handleSelectedProducts
 * @property {(filter: ProductFilter) => void} handleFilterChanged
 */
export type ProductListDataContextType = {
  brandContext?: string;
  autoSelectedProducts?: Product[];
  selectedProducts: Product[];
  smartCampaignConfig?: SmartCampaignConfig;
  handleAutoSelectedProducts: (
    fn: (autoSelectedProducts: Product[]) => Product[],
  ) => void;
  handleSelectedProducts: (
    fn: (selectedProducts: Product[]) => Product[],
  ) => void;
  handleFilterChanged: (filter: ProductFilter) => void;
};

export const ProductListDataContext =
  React.createContext<ProductListDataContextType>({
    brandContext: '',
    autoSelectedProducts: [],
    selectedProducts: [],
    smartCampaignConfig: undefined,
    handleSelectedProducts: () => {
      // This is intentionally left blank
    },
    handleAutoSelectedProducts: () => {
      // This is intentionally left blank
    },
    handleFilterChanged: () => {
      // This is intentionally left blank
    },
  });
